// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N200, N40, N50A, N60A } from '@atlaskit/theme/colors';
import { layers } from '@atlaskit/theme/constants';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AutocompleteContainer = styled.div({
  position: 'absolute',
  backgroundColor: "var(--ds-surface-overlay, white)",
  borderRadius: "var(--ds-border-radius-100, 3px)",
  willChange: 'top, left',
  zIndex: layers.dialog(),
  boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"),
  padding: "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-0, 0)"),
  minWidth: '200px',
  maxWidth: '400px',
  '&:focus': {
    outline: 'none'
  },
  marginLeft: "var(--ds-space-negative-100, -8px)",
  marginTop: "var(--ds-space-200, 16px)"
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? css({
    visibility: 'visible'
  }) : css({
    visibility: 'hidden'
  });
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AutocompleteOptionsContainer = styled.div({
  maxHeight: '288px',
  overflow: 'auto'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var OptionList = styled.ul({
  listStyle: 'none',
  margin: "var(--ds-space-0, 0)",
  padding: "var(--ds-space-0, 0)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AutocompleteLoadingFooter = styled.div({
  display: 'flex',
  justifyContent: 'center',
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  fontStyle: 'italic',
  padding: "var(--ds-space-150, 12px)",
  textAlign: 'center'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref2) {
  var hasOptions = _ref2.hasOptions;
  return hasOptions && {
    borderTop: "solid 1px ".concat("var(--ds-border, ".concat(N40, ")")),
    marginTop: "var(--ds-space-075, 6px)",
    paddingTop: "var(--ds-space-250, 20px)"
  };
});